import { render, staticRenderFns } from "./carInfor.vue?vue&type=template&id=6055bf1a&scoped=true&"
import script from "./carInfor.vue?vue&type=script&lang=js&"
export * from "./carInfor.vue?vue&type=script&lang=js&"
import style0 from "./carInfor.vue?vue&type=style&index=0&id=6055bf1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055bf1a",
  null
  
)

export default component.exports